/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetAmountModel {
    getFixupPrototypeFunction() { return BudgetAmountModel.fixupPrototype; }

    static newInstance(model: Partial<BudgetAmountModel>): BudgetAmountModel {
        let obj = Object.assign(new BudgetAmountModel(), model);
        BudgetAmountModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetAmountModel>): BudgetAmountModel {
        if (!model) return null;
        return BudgetAmountModel.newInstance(<BudgetAmountModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetAmountModel) {
        if (!obj) return;

        models.BudgetAmountModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetAmountModel): boolean {
        Object.setPrototypeOf(obj, BudgetAmountModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.amount === undefined) {
            this.amount = 0;
        }
        if (this.budget_growth === undefined) {
            this.budget_growth = 0;
        }
        if (this.planned_budget_limit) {
            for (let val of this.planned_budget_limit) {
                models.BudgetLimitModel.fixupPrototype(val);
            }
        }
    }

    /**
     * budget amount
     */
    amount: number;

    /**
     * type of budget amount. Allowed values will be auto_increment/auto_suggest/fixed
     */
    type: string;

    /**
     * planned budget_limit for auto_suggest/auto_increment type
     */
    planned_budget_limit: Array<models.BudgetLimitModel>;

    /**
     * Percentage value for auto_increment type only
     */
    budget_growth: number;

}
